import createCollectionStore from '../create';
import { fetchAll, saveProductInstance, terminateProductInstance } from '../../core-data';
import { ProductInstance } from '../../core-data/types';
import UUID from 'uuid';
import PendingProductInstanceCollection from './pending-product-instance';

export default createCollectionStore(
  'ProductInstance',
  false,
  () => fetchAll(ProductInstance),
  'uuid',
  [],
  {
    save: async (state, actions, productInstance, pendingProductInstanceIdentifier = null) => {
      const modified = {
        uuid: UUID.v4(),
        ...productInstance
      };
      await saveProductInstance(modified, pendingProductInstanceIdentifier);
      await actions.updateCache(modified);
      if (pendingProductInstanceIdentifier) {
        await PendingProductInstanceCollection.actions.removeCached(pendingProductInstanceIdentifier);
      }
      return { };
    },
    remove: async (state, actions, uuid) => {
      await terminateProductInstance(uuid);
      await actions.removeCached(uuid);
    }
  }
);



// WEBPACK FOOTER //
// ./src/services/collection/collections/product-instance.js